var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35544 9.83561L11.5878 1.4045C11.9101 1.08464 11.9101 0.55975 11.5878 0.239893C11.2655 -0.0799643 10.7423 -0.0799643 10.4208 0.239893L0.594587 9.2123C0.423176 9.38453 0.349363 9.61417 0.361666 9.83561C0.349363 10.0652 0.423176 10.2949 0.594587 10.4671L10.4208 19.4395C10.7423 19.7594 11.2655 19.7594 11.5878 19.4395C11.9101 19.1115 11.9101 18.5948 11.5878 18.2749L2.35544 9.83561Z",
    fill: "#131314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPreviousIcon);
export default __webpack_public_path__ + "static/media/leftPreviousIcon.d398f4c8c4a4234b9b0e6ca4d4303d4c.svg";
export { ForwardRef as ReactComponent };